export const getArticles = () => {
  try {
    const targetUrl =
      "https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/@Cookeai";
    return fetch(targetUrl).then((response) => response.json());
  } catch (err) {
    console.log(err);
    return null;
  }
};
